<ion-header no-border mode="md">

    <ion-toolbar color="light" mode="md">

        <ion-card-title color="primary" slot="start" style="margin-left: 15px;">
            {{ '360evaluation.changeRelationship' | translate | uppercase }}
        </ion-card-title>
        <ion-buttons slot="end">
            <ion-button color="light" (click)="dismiss(true)" mode="ios">
                <ion-icon class="bp-close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>

    <ion-item class="user-details">
        <ion-col class="user-left" size="3">
            <img [src]="userEvaluated.imageUrl" default="">
        </ion-col>
        <ion-col size="9" class="user-left">
            <span>{{ userEvaluated.name | uppercase }}</span>
        </ion-col>
    </ion-item>
    <div class="buttons">
        <div class="styled-input-single">
            <input type="radio" name="fieldset-1" id="radio-manager"
                   [checked]="relation !== relationshipTranslation"
                   (click)="changeRelationship()"/>
            <label for="radio-manager">
                {{ "generic.manager" | translate }}
            </label>
        </div>
        <div class="styled-input-single">
            <input type="radio" name="fieldset-1" id="radio-360" [checked]="relation === relationshipTranslation"
                   (click)="changeRelationship()"/>
            <label for="radio-360">
                {{ "360" }}
            </label>
        </div>        
    </div>
</ion-content>

<ion-footer class="ion-text-center">
    <ion-button
            color="primary"
            mode="ios"
            slot="center"
    (click)="saveChangeRelationship()">
        {{ 'generic.save' | translate | uppercase }}
    </ion-button>
</ion-footer>